import { createTheme } from '@mui/material';

export const defaultTheme = createTheme({
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'Public Sans',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          '&:first-of-type': {
            borderTopLeftRadius: '8px',
            borderBottomLeftRadius: '8px',
          },

          '&:last-of-type': {
            borderTopRightRadius: '8px',
            borderBottomRightRadius: '8px',
          },
        },
      },
    },
  },
});
